import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".Tag-module_tag__lor5Z {\n  max-width: 76px;\n  border-radius: 8px;\n  padding: 4px 8px;\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #484c51;\n  background-color: #f4f6f8;\n}";
var styles = {"tag":"Tag-module_tag__lor5Z"};
styleInject(css_248z);

export { styles as default };
